import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import api from "@/lib/api";
import { VendorCard } from "@/components/discovery/VendorCard";
import { FEATURED_DISCLOSURE, breadcrumbLd } from "@/lib/siteContent";

const crumbs = [{ label: "Home", to: "/" }, { label: "Featured Vendors", to: "/featured-vendors" }];

export default function FeaturedVendors() {
  const [vendors, setVendors] = useState([]);
  useEffect(() => { api.get("/discovery/featured?limit=12").then((r) => setVendors(r.data)).catch(() => {}); }, []);

  return (
    <div className="ca-container py-12">
      <Seo title="Featured Vendors and Sponsored Business Listings | ComplaintAdvisor"
        description="Explore clearly labelled featured and sponsored vendor listings across service categories. Paid placement does not affect reviews, complaints, or moderation decisions."
        path="/featured-vendors" jsonld={breadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-3 flex items-center gap-2"><Star className="h-7 w-7 text-amber-500" /> Featured Vendors</h1>
      <p className="text-slate-700 mt-3 max-w-2xl">
        This section contains vendors who have selected a paid promotional or featured placement option. Featured status
        describes placement or promotion only. It does not certify service quality or guarantee customer satisfaction.
      </p>
      <div className="mt-4 rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm text-amber-800" data-testid="featured-disclosure">{FEATURED_DISCLOSURE}</div>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {vendors.map((v) => <VendorCard key={v.slug} v={v} />)}
        {!vendors.length && <p className="text-sm text-slate-400">No featured vendors at the moment.</p>}
      </div>
    </div>
  );
}
